import { OwnershipState } from './state';
import { Ownership } from '@services/ownership/types/ownership';
import { ValidOwnershipType } from '@services/ownership/types/valid-ownership-type';
export const assetsListOfuser = (
  state: OwnershipState,
  userId?: string,
  ownershipType?: ValidOwnershipType
): Ownership[] => {
  if (!userId || !ownershipType) {
    return [];
  }
  return Object.values(state.assets)
    .map((asset) => Object.values(asset))
    .flat()
    .filter(
      (asset) =>
        asset.ownerId === userId && asset.ownershipType === ownershipType
    );
};

export const assetOwnersByType = (
  asset: {
    [ownershipId: string]: Ownership;
  },
  ownershipType?: ValidOwnershipType
): Ownership[] => {
  if (!asset) return [];

  return Object.values(asset)
    .filter((o) => (ownershipType ? o.ownershipType === ownershipType : true))
    .sort(
      (a, b) =>
        (a.order === undefined ? 1 : a.order) -
        (b.order === undefined ? 1 : b.order)
    );
};

export const assetOwnersById = (
  assets: {
    [assetId: string]: {
      [ownershipId: string]: Ownership;
    };
  },
  assetId: string,
  ownershipType?: ValidOwnershipType
): Ownership[] => {
  if (!(assetId in assets)) {
    return [];
  }

  return Object.values(assets[assetId])
    .filter((o) => (ownershipType ? o.ownershipType === ownershipType : true))
    .sort(
      (a, b) =>
        (a.order === undefined ? 1 : a.order) -
        (b.order === undefined ? 1 : b.order)
    );
};

export const assetOwners = (
  state: OwnershipState,
  assetId: string,
  ownershipType?: ValidOwnershipType
): Ownership[] => {
  if (!(assetId in state.assets)) {
    return [];
  }

  return Object.values(state.assets[assetId])
    .filter((o) => (ownershipType ? o.ownershipType === ownershipType : true))
    .sort(
      (a, b) =>
        (a.order === undefined ? 1 : a.order) -
        (b.order === undefined ? 1 : b.order)
    );
};

export const ownersList = (
  state: OwnershipState,
  assetId: string
): Ownership[] => {
  return assetOwners(state, assetId, 'OWNER');
};

export const writersList = (
  state: OwnershipState,
  assetId: string
): Ownership[] => {
  return assetOwners(state, assetId, 'WRITER');
};

export const getOwnershipTotal = (
  state: OwnershipState,
  assetId: string,
  ownershipType: ValidOwnershipType = 'OWNER'
): number => {
  const ownership = assetOwners(state, assetId, ownershipType);

  if (!ownership.length) {
    return 0;
  }

  return ownership.reduce((memo, o) => memo + o.split, 0);
};
